import { render, staticRenderFns } from "./ProductsListView.vue?vue&type=template&id=0e5bcb30&scoped=true&"
import script from "./ProductsListView.vue?vue&type=script&lang=ts&"
export * from "./ProductsListView.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsListView.vue?vue&type=style&index=0&id=0e5bcb30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5bcb30",
  null
  
)

export default component.exports